import { Link } from 'react-router-dom'

/**
 * The dark band that opens every sub-page.
 *
 * It matters structurally, not just visually: the sticky header is transparent
 * at scroll position 0 and relies on sitting over a dark surface, so every route
 * has to start with one of these (or the home page's `Hero`).
 *
 * @param {object} props
 * @param {string} [props.eyebrow]
 * @param {string} props.title
 * @param {string} [props.lead]
 * @param {Array<{label: string, to?: string}>} [props.breadcrumb]
 *   Trail after "Start"; the last entry is marked as the current page.
 */
export default function PageHero({
  eyebrow,
  title,
  lead,
  breadcrumb = [],
  children,
}) {
  return (
    <header className="page-hero on-dark">
      <div className="blueprint" aria-hidden="true" />
      <div
        className="glow glow--gold"
        aria-hidden="true"
        style={{
          width: '26rem',
          height: '26rem',
          right: '-8rem',
          top: '-10rem',
          opacity: 0.35,
        }}
      />
      <div className="container">
        <div className="page-hero__inner">
          {breadcrumb.length > 0 ? (
            <nav aria-label="Brotkrumen-Navigation">
              <ol className="breadcrumb">
                <li>
                  <Link to="/">Start</Link>
                </li>
                {breadcrumb.map((crumb, index) => {
                  const isLast = index === breadcrumb.length - 1
                  return (
                    <li key={crumb.label}>
                      {crumb.to && !isLast ? (
                        <Link to={crumb.to}>{crumb.label}</Link>
                      ) : (
                        <span aria-current={isLast ? 'page' : undefined}>
                          {crumb.label}
                        </span>
                      )}
                    </li>
                  )
                })}
              </ol>
            </nav>
          ) : null}

          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          <h1 className="page-hero__title">{title}</h1>
          {lead ? <p className="page-hero__lead">{lead}</p> : null}
          {children ? <div className="page-hero__actions">{children}</div> : null}
        </div>
      </div>
    </header>
  )
}
